Namespace 'Models'

class Models.InstagramUser
  constructor: (id, username, name, profilePictureUrl) ->
    @id = id
    @username = username
    @name = name
    @profilePictureUrl = profilePictureUrl
